const resetBundle = (variant) => {
  const activeBundleTitle = document.querySelector('.active-bundle-title');
  const activeBundleDesc = document.querySelector('.active-bundle-desc');
  const activeBundlePrice = document.querySelector('.active-bundle-price');
  const submitButton = document.querySelector('.add-bundle-to-cart');
  const scentType = document.querySelector('.bundle-scent-type');
  let limit = parseInt(document.querySelector('.bundle-set-variants-wrapper input:checked').dataset.limit);

  if(activeBundleTitle) {
    activeBundleTitle.innerText = variant.dataset.title;
  }
  if(activeBundleDesc) {
    activeBundleDesc.innerText = variant.dataset.subtitle;
  }
  if(activeBundlePrice) {
    activeBundlePrice.innerText = variant.dataset.price;
  }
  if(submitButton) {
    const custom_button_title = activeBundleTitle.innerText.includes("Pouch")
      ? window?.bundleSettings?.gift_pouch_button_label
      : window?.bundleSettings?.gift_set_button_label;

    submitButton.querySelector('.btn-price').innerText = variant.dataset.price;
    submitButton.querySelector(".btn-title").innerText = custom_button_title || `add ${limit} ${variant.dataset.title}s`;
  }

  if(variant.dataset.scentTypeEnabled == 'true') {
    scentType.classList.remove('hidden');
  }
  else {
    scentType.classList.add('hidden');
  }

  initSetPreviewPlaceholder();
  initBundlePreviewSticky(true);

  let activeBundleCollection = document.querySelector('.bundle-set-collection-item.active');
  let targetBundleCollection = document.querySelector(`.bundle-set-collection-item[data-variant-id="${variant.value}"]`);

  activeBundleCollection.querySelectorAll('.bundle-set-item').forEach((item) => {
    item.classList.remove('added', 'disabled');
    item.querySelector('input').value = 1;
  })

  document.querySelectorAll('.bundle-set-preview-item').forEach((pItem, index) => {
    const translations = activeBundleTitle.innerText.includes('Pouch') ? window?.bundleSettings?.pouch_title : window?.bundleSettings?.set_title;
    pItem.classList.remove('active', 'ready');
    if(index == 0) {
      pItem.classList.add('ready');
    }
    pItem.removeAttribute('data-variant-id');
    pItem.removeAttribute('data-product-id');
    pItem.querySelector('.bundle-set-preview-image').innerHTML = '';
    pItem.querySelector('.bundle-set-preview-title').innerText = translations?.[index] || `${activeBundleTitle.innerText} ${index + 1}`;
  })

  document.querySelector('.add-bundle-to-cart').setAttribute('disabled', 'true');

  if(activeBundleCollection != targetBundleCollection) {
    activeBundleCollection.classList.remove('active');
    targetBundleCollection.classList.add('active');
  }
}

const addItemToBundle = (item) => {

  item.classList.add('added');

  let targetPreviewItem = document.querySelector('.bundle-set-preview-item.ready');
  if(targetPreviewItem) {
    targetPreviewItem.setAttribute('data-variant-id', item.dataset.variantId);
    targetPreviewItem.setAttribute('data-product-id', item.dataset.productId);
    targetPreviewItem.querySelector('.bundle-set-preview-image').innerHTML = `<img src="${item.dataset.imageUrl}" />`;
    targetPreviewItem.querySelector('.bundle-set-preview-title').innerText = `${item.querySelector('.item--title').innerText}${item.dataset.variantName ? ('-' + item.dataset.variantName) : ''}`;
  }
  targetPreviewItem.classList.remove('ready');
  targetPreviewItem.classList.add('active');
  if(targetPreviewItem.nextElementSibling) {
    targetPreviewItem.nextElementSibling.classList.add('ready');
  }
  updateBtnStatus();
}

const updateBtnStatus = () => {
  let activePreviewCount = document.querySelectorAll('.bundle-set-preview-item.active').length;
  let activePreviewLimit = parseInt(document.querySelector('.bundle-set-variants-wrapper input:checked').dataset.limit);

  document.querySelectorAll('.bundle-set-collection-item.active .bundle-set-item').forEach((item) => {
    if(activePreviewCount < activePreviewLimit) {
      item.classList.remove('disabled');
    }
    else {
      item.classList.add('disabled');
    }
  })

  if(activePreviewCount < activePreviewLimit) {
    document.querySelector('.add-bundle-to-cart').setAttribute('disabled', 'true');
  }
  else {
    document.querySelector('.add-bundle-to-cart').removeAttribute('disabled');
  }
}

const removeItemFromBundle = (item) => {

  let itemId = item.dataset.variantId;
  let itemProductId = item.dataset.productId;

  item.querySelector('.bundle-set-preview-image').innerHTML = '';
  item.classList.remove('active');

  const activeBundleTitle = document.querySelector('.active-bundle-title');
  const translations = activeBundleTitle.innerText.includes('Pouch') ? window?.bundleSettings?.pouch_title : window?.bundleSettings?.set_title;

  document.querySelectorAll('.bundle-set-preview-item').forEach((previewItem, index) => {
    let nextItem = previewItem.nextElementSibling;

    previewItem.querySelector('.bundle-set-preview-title').innerText = translations?.[index] || `${activeBundleTitle.innerText} ${index + 1}`;

    if(nextItem && nextItem.classList.contains('active') && ((index + 1) >= parseInt(item.dataset.index))) {
      previewItem.querySelector('.bundle-set-preview-image').innerHTML = nextItem.querySelector('.bundle-set-preview-image').innerHTML;
      previewItem.querySelector('.bundle-set-preview-title').innerText = nextItem.querySelector('.bundle-set-preview-title').innerText;
      previewItem.setAttribute('data-variant-id', nextItem.dataset.variantId);
      previewItem.setAttribute('data-product-id', nextItem.dataset.productId);
      previewItem.classList.remove('ready');
      previewItem.classList.add('active');

      nextItem.querySelector('.bundle-set-preview-image').innerHTML = '';
      nextItem.querySelector('.bundle-set-preview-title').innerText = window?.bundleSettings?.set_title[index] || `${document.querySelector('.active-bundle-title').innerText} ${nextItem.dataset.index}`;
      nextItem.removeAttribute('data-variant-id');
      nextItem.removeAttribute('data-product-id');
      nextItem.classList.remove('active');
    }
  })
  let is_set = false;
  document.querySelectorAll('.bundle-set-preview-item').forEach((pItem) => {
    if(!pItem.classList.contains('active') && !is_set) {
      pItem.classList.add('ready');
      is_set = true;
    }
    else {
      pItem.classList.remove('ready');
    }
    if(!pItem.classList.contains('active')) {
      pItem.removeAttribute('data-variant-id');
      pItem.removeAttribute('data-product-id');
    }
  })

  let setItem = document.querySelector(`.bundle-set-item[data-product-id="${itemProductId}"]`);
  let setItemQtyInput = setItem.querySelector('input');

  if(parseInt(setItemQtyInput.value) > 1) {
    setItemQtyInput.value = parseInt(setItemQtyInput.value) - 1;
  }
  else {
    setItem.classList.remove('added');
  }

  updateBtnStatus();
}

const addBundleToCart = async () => {
  let cartDrawer = document.querySelector('cart-drawer');
  let variantId = document.querySelector('.bundle-set-variants-wrapper input:checked').value;
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData();

  formData.append('id', variantId);
  formData.append('quantity', 1);

  // document.querySelectorAll('.bundle-set-collection-item.active .bundle-set-item.added').forEach((item, index) => {
  //   let p_name = item.querySelector('.item--title').innerText;
  //   let p_value = item.querySelector('input').value;
  //   formData.append(`properties[Set ${index + 1}]`, `${p_name}: ${p_value}`);
  // })
  let addedItems = document.querySelectorAll('.bundle-set-preview-wrapper .bundle-set-preview-item')
  addedItems.forEach((item, index) => {
    let count = 1;
    let p_name = item.querySelector('.bundle-set-preview-title').innerText;
    let is_repeated = false;
    addedItems.forEach((_item, _index) => {
      if(p_name == _item.querySelector('.bundle-set-preview-title').innerText) {
        if(index > _index) {
          is_repeated = true;
        }
        if(index < _index) {
          count ++;
        }
      }
    })
    if(!is_repeated) {
      formData.append(`properties[Set ${index + 1}]`, `${p_name}: ${count}`);
    }
  })

  if(document.querySelector('.scent-type.custom-blend').classList.contains('active') && !document.querySelector('.bundle-scent-type').classList.contains('hidden')) {
    if(document.querySelector('.input_custom_scent_name').value != null) {
      formData.append(`properties[Scent Name]`, `${document.querySelector('.input_custom_scent_name').value}`);
    }
    if(document.querySelector('.input_custom_recipients_name').value != null) {
      formData.append(`properties[Recipient Name]`, `${document.querySelector('.input_custom_recipients_name').value}`);
    }
  }

  formData.append(
    'sections',
    cartDrawer
      .getSectionsToRender()
      .map(section => section.section)
  );
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
  .then(response => response.json())
  .then(response => {
    if (response.status) {
      return;
    }
    cartDrawer.renderContents(response);
 
  })
  .catch(error => {
    console.error(error);
  })
  .finally(() => {
  });
}

const initSetPreviewPlaceholder = () => {
  const activeBundleTitle = document.querySelector('.active-bundle-title');
  const translations = activeBundleTitle.innerText.includes('Pouch') ? window?.bundleSettings?.pouch_title : window?.bundleSettings?.set_title;

  let wrapper = document.querySelector('.bundle-set-preview-wrapper');
  let activeVariant = document.querySelector('.bundle-set-variants-wrapper input:checked');
  let limit = parseInt(activeVariant.dataset.limit);
  let title = activeVariant.dataset.title;
  let html = '';
  for (let count = 0; count < limit; count ++) {
    html += `
      <div class="bundle-set-preview-item${count == 0 ? ' ready' : ''}" data-index="${count + 1}">
        <span class="remove-preview">
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="6 6 12 12" width="1em" height="1em">
            <path d="M17.25 6.75L6.75 17.25" stroke="currentColor" stroke-width="1" stroke-linecap="square" stroke-linejoin="round"></path>
            <path d="M6.75 6.75L17.25 17.25" stroke="currentColor" stroke-width="1" stroke-linecap="square" stroke-linejoin="round"></path>
          </svg>
        </span>
        <div class="bundle-set-preview-image"></div>
        <div class="bundle-set-preview-title">
          ${translations?.[count] || `${title} ${count + 1}`}
        </div>
      </div>
    `;
  }
  wrapper.dataset.limit = limit;
  wrapper.innerHTML = html;

  // Remove preview item
  document.querySelectorAll('.bundle-set-preview-item .remove-preview').forEach((remove) => {
    remove.addEventListener('click', () => {
      removeItemFromBundle(remove.closest('.bundle-set-preview-item'));
    })
  })

}

const initBundlesetEvents = () => {
  // Variant change
  document.querySelectorAll('.bundle-set-variants-wrapper input').forEach((variant) => {
    variant.addEventListener('change', () => {
      resetBundle(variant);
    })
  })

  // Add bundle item
  document.querySelectorAll('[data-add-to-bundle]').forEach((addToBundle) => {
    addToBundle.addEventListener('click', () => {
      addItemToBundle(addToBundle.closest('.bundle-set-item'));
    })
  })

  // Qty button clicked
  document.querySelectorAll('.bundle-quantity .quantity-plus').forEach((plus) => {
    plus.addEventListener('click', () => {
      let input = plus.closest('.bundle-quantity').querySelector('input');
      input.value = parseInt(input.value) + 1;
      addItemToBundle(plus.closest('.bundle-set-item'));
    })
  })
  document.querySelectorAll('.bundle-quantity .quantity-minus').forEach((minus) => {
    minus.addEventListener('click', () => {
      let previewItem = null;
      document.querySelectorAll('.bundle-set-preview-item').forEach((pItem) => {
        if(pItem.dataset.productId == minus.closest('.bundle-set-item').dataset.productId) {
          previewItem = pItem;
        }
      })
      removeItemFromBundle(previewItem);
    })
  })

  // Add bundle to cart
  document.querySelector('.add-bundle-to-cart').addEventListener('click', () => {
    addBundleToCart();
  })
  
  // Scent button
  document.querySelectorAll('.scent-type-buttons button').forEach((scentButton) => {
    scentButton.addEventListener('click', () => {
      if(!scentButton.classList.contains('active')) {
        document.querySelector('.scent-type-buttons button.active').classList.remove('active', 'button--filled');
        document.querySelector('.custom-blend-info').classList.toggle('hidden');
        scentButton.classList.add('active', 'button--filled');
      }
    })
  })

  // Bundle variant selector
  document.querySelectorAll('.set-variant-swatch').forEach((select) => {
    select.addEventListener('change', () => {
      select.closest('.bundle-set-item').setAttribute('data-variant-id', select.value);
      select.closest('.bundle-set-item').setAttribute('data-variant-name', select.options[select.selectedIndex].innerText);
    })
  })

}

const initBundlePreviewSticky = (setHeight = false) => {

  if(window.innerWidth > 768) return;

  const sectionHeader = document.querySelector('.shopify-section-group-header-group');
  const summaryContent = document.querySelector('.bundle-set-summary-content');
  const summaryContentEl = summaryContent.querySelector('.bundle-set-preview');
  
  if(setHeight) {
    summaryContent.style.height = `${summaryContentEl.scrollHeight}px`;
    summaryContent.classList.add('sticky');
  }

  if(summaryContent.getBoundingClientRect().top <= sectionHeader.scrollHeight) {
    summaryContent.classList.add('fixed');
  }
  else {
    summaryContent.classList.remove('fixed');
  }

}

document.addEventListener("DOMContentLoaded", () => {
  initBundlesetEvents();
  initSetPreviewPlaceholder();
  initBundlePreviewSticky(true);
})

window.addEventListener('scroll', () => {
  initBundlePreviewSticky();
})